<div class="card card-transaction">
  <div class="card-header">
    <div>
      <h4 class="card-title">{{ "DEMANDS.HOLIDAYS" | translate }}, {{ "DEMANDS.PERMISSIONS" | translate }} {{ "AND" | translate }} {{ "DEMANDS.SICKNESS" | translate }}</h4>
      <p class="font-small-3 mb-0">{{ "UPDATE_DATE" | translate }} {{ getLastUpdateDate() }}</p>
    </div>
  </div>
  <div class="card-body pt-0">
    <div class="d-flex justify-content-between mb-05">
      <h6 class="font-size-4">{{ "HOLIDAYS_NOT_TAKEN" | translate }}</h6>
      <div class="font-weight-bolder text-{{ residual_holidays.includes('+') ? 'success' : residual_holidays.includes('-') ? 'danger' : 'normal' }}">{{ residual_holidays }}</div>
    </div>
    <div class="d-flex justify-content-between mb-1 border-bottom pb-2">
      <h6 class="font-size-4">{{ "PERMISSION_NOT_TAKEN" | translate }}</h6>
      <div class="font-weight-bolder text-{{ residual_permissions.includes('+') ? 'success' : residual_permissions.includes('-') ? 'danger' : 'normal' }}">{{ residual_permissions }}</div>
    </div>
    <div *ngIf="!_absenceService.myLastFiveAbsence && _absenceService.myLastFiveAbsence?.length < 1">{{ "NO_REQUEST" | translate }}</div>
    <div *ngFor="let absence of _absenceService.myLastFiveAbsence" class="row mb-1">
      <div class="col-12">
        <div class="mr-1 text-capitalize font-weight-bold font-medium-1 text-success" *ngIf="absence.status === 1" [ngbTooltip]="'APPROVED' | translate">
          {{ absence.type.name }}
        </div>
        <div class="mr-1 text-capitalize font-weight-bold font-medium-1 text-warning" *ngIf="absence.status === 0" [ngbTooltip]="'PENDING' | translate">
          {{ absence.type.name }}
        </div>
        <div class="mr-1 text-capitalize font-weight-bold font-medium-1 text-danger" *ngIf="absence.status === 2" [ngbTooltip]="'REJECTED' | translate">
          {{ absence.type.name }}
        </div>
        <div class="font-small-3 mt-025">{{ getFormat(absence.from, absence) }} - {{ getFormat(absence.to, absence) }}</div>
      </div>
    </div>
    <div class="d-flex mt-2">
      <div ngbDropdown class="btn-group">
        <button ngbDropdownToggle type="button" class="btn btn-outline-primary" rippleEffect>{{ "REQUIRE" | translate }}</button>
        <div ngbDropdownMenu>
          <a ngbDropdownItem href="javascript:void(0)" (click)="_utilsService.toggleAbsencePopup('holidays')">{{ "DEMANDS.HOLIDAYS" | translate }}</a>
          <a ngbDropdownItem href="javascript:void(0)" (click)="_utilsService.toggleAbsencePopup('permissions')">{{ "DEMANDS.PERMISSIONS" | translate }}</a>
          <a ngbDropdownItem href="javascript:void(0)" (click)="_utilsService.toggleAbsencePopup('sickness')">{{ "DEMANDS.SICKNESS" | translate }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
